
import { lazy, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import MainLayout from "../layout/mainLayout";
const Orders = lazy(() => import("../Pages/orders/orders"));
const Account = lazy(() => import("../Pages/account/account"));
const OrderSuccess = lazy(() => import("../Pages/orderSuccess"));
const Faq = lazy(() => import("../Pages/account/faq"));
const ContactSupport = lazy(() => import("../Pages/account/contactSupport"));
const TermsPrivacy = lazy(() => import("../Pages/account/termsPrivacy"));
const AboutRefuelex = lazy(() => import("../Pages/account/aboutRefuelex"));
const Notification = lazy(() => import("../Pages/account/notification"));
import { useDrawerOpenFun } from "../Context/modelContext";

const LoginChecker = () => {
    const location = useLocation();
    const { setLoginModal } = useDrawerOpenFun();

    const loginCheck = Boolean(sessionStorage.getItem("refreshToken"));

    useEffect(() => {
        if (!loginCheck) {
            setLoginModal(true);
        }
    }, [loginCheck, setLoginModal]);

    if (!loginCheck) {
        return (
            <Navigate 
                to="/" 
                state={{ from: location }} 
                replace 
            />
        );
    }

    return <Outlet />;
};



export const privateRoutes = [
    {
        path: "/main",
        element: <LoginChecker />,
        children: [
            {
                element: <MainLayout />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="home" replace />,
                    },
                    { path: "orders", element: <Orders /> },
                    { path: "account", element: <Account /> },
                    { path: "orderSuccess", element: <OrderSuccess /> },
                    { path: "faq", element: <Faq /> },
                    { path: "contact-support", element: <ContactSupport /> },
                    { path: "terms-privacy", element: <TermsPrivacy /> },
                    { path: "about-refuelex", element: <AboutRefuelex /> },
                    { path: "notification", element: <Notification /> },
                ],  
            },
        ],
    },
];